import React from 'react';

import { Alert as AntdAlert } from 'antd';

import { ConditionsReactivateFooterLinkDto } from 'lib_api/lib/api/gen/api';

interface ConditionReactivateProps {
  conditions?: ConditionsReactivateFooterLinkDto;
}

function ConditionReactivateFooterLink({
  conditions,
}: ConditionReactivateProps): React.ReactElement {
  const isInvalid: boolean =
    (conditions?.linkValid || conditions?.alreadyExist) ?? false;

  return (
    <>
      {isInvalid && (
        <AntdAlert
          type="warning"
          className="alertInvalid"
          message={
            <>
              {conditions?.linkValid && (
                <p className="alertInvalid--txt">Le lien est déjà valide.</p>
              )}
              {conditions?.alreadyExist && (
                <p className="alertInvalid--txt">Le lien existe déjà.</p>
              )}
            </>
          }
        />
      )}
    </>
  );
}

export default ConditionReactivateFooterLink;
